import Styles from "./BuySell.module.css";
import React, { useEffect, useState, useCallback } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import {
  getArchive,
  getConnectionHistory,
} from "../../../Services/BuySell/Listing";
import { useDispatch, useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { formatDate, formatSlotTime } from "../../../helpers/dateFormat";
import {
  fetchLedgerBids,
  fetchMainScreenActiveConnection,
} from "../../../Redux/Slices/CapacitySlice";
import { LeftSideBtns } from "../../Bilateral/LedgerViewContent/ledgerUploadDocs";
import { openBilateralChat } from "../../Modals/Banking/CreateEdit/helpers";
import { useLocation } from "react-router-dom";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import Loader from "../../../commons/Loader/Loader";
import { ReactComponent as EyeIcon } from "../../../assets/images/view.svg";
import ViewInjectionModal from "../../Modals/ConGen/ViewInjectionModal/ViewInjectionModal";
import LoadMorePagination from "../../LoadeMore";

const ConnectionModal = ({ open, onClose, connectionId }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [connectionData, setConnectionData] = useState([]);
  const [activeId, setActiveId] = useState("");
  const [openInjectionModal, setOpenInjectionModal] = useState(false);

  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  );
  const userDataKey =
    role === "CONSUMER" ? "capacityGenerator" : "capacityConsumer";
  const oppositeuserDataKey =
    role === "CONSUMER" ? "capacityConsumer" : "capacityGenerator";

  const fetchConnectionHistory = useCallback(async () => {
    try {
      if (!open) return;
      setLoading(true);
      const res = await getConnectionHistory(connectionId, role);
      if (res?.data?.code === 200) {
        setConnectionData(res?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching connection history:", error);
    } finally {
      setLoading(false);
    }
  }, [connectionId, open, role]);

  useEffect(() => {
    fetchConnectionHistory();
  }, [connectionId, fetchConnectionHistory]);
  return (
    <>
      {" "}
      {openInjectionModal && (
        <ViewInjectionModal
          open={openInjectionModal}
          handleClose={() => {
            setOpenInjectionModal(false);
            setActiveId("");
          }}
          data={
            connectionData?.find((ele) => ele[userDataKey]?.id === activeId)[
              userDataKey
            ]
          }
        />
      )}
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading  ${Styles.modalHeading}`}
          >
            <div className="headingText">Connection History</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={onClose}
            />
          </div>
          <div className={Styles.docContainer}>
            <table
              className={Styles.connectionHistoryTable}
              style={{ width: "100%", tableLayout: "fixed" }}
            >
              <colgroup>
                <col style={{ width: "20%" }} />
                <col style={{ width: "26%" }} />
                <col style={{ width: "13%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "33%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Requisitions</th>
                  <th>EMD</th>
                  <th>Initial Margin</th>
                  <th>Action</th>
                </tr>
              </thead>
            </table>

            <div className={Styles.docContentScroll}>
              {loading ? (
                <div className={Styles.loadingRow}>
                  <Loader />
                </div>
              ) : Array.isArray(connectionData) && connectionData.length > 0 ? (
                <table
                  className={Styles.connectionHistoryTable}
                  style={{ width: "100%", tableLayout: "fixed" }}
                >
                  <colgroup>
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "26%" }} />
                    <col style={{ width: "13%" }} />
                    <col style={{ width: "15%" }} />
                    <col style={{ width: "33%" }} />
                  </colgroup>
                  <tbody>
                    {connectionData.map((doc) => (
                      <tr key={doc.id}>
                        <td style={{ fontSize: "12px" }}>
                          {doc[userDataKey]?.name || "-"}
                        </td>

                        <td
                          style={{
                            cursor: "pointer",
                            color: "#617499",
                            textDecoration: "underline",
                          }}
                          onClick={() => {
                            setOpenInjectionModal(true);
                            setActiveId(doc[userDataKey].id);
                          }}
                        >
                          View Details
                        </td>

                        <td>{doc[userDataKey]?.emd || "-"} (₹/KWh)</td>

                        <td>{doc[userDataKey]?.initialMargin || "-"}%</td>

                        <td
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <div className={Styles.connectionBtns}>
                            <div
                              onClick={() => {
                                let chatId;
                                if (role === "CONSUMER") {
                                  chatId = `${doc[oppositeuserDataKey]?.split("_")?.[0]}_${doc[userDataKey]?.name?.split("_")?.[0]}`;
                                } else {
                                  chatId = `${doc[userDataKey]?.name?.split("_")?.[0]}_${doc[oppositeuserDataKey]?.split("_")?.[0]}`;
                                }
                                openBilateralChat(dispatch, {
                                  header: doc[userDataKey]?.name,
                                  fromUser: doc[oppositeuserDataKey]?.name,
                                  toUser: doc[userDataKey]?.name,
                                  chatId: chatId,
                                  type: "BILATERAL",
                                  hidechat: false,
                                });
                              }}
                              className={Styles.chatBtn}
                            >
                              Chat History
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className={Styles.connectHistory}>
                  No connection history found.
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

const LoaderNoData = ({ loading, dataLength }) => {
  if (loading) {
    return (
      <div className={Styles.loaderContainer}>
        <div className={Styles.loader} role="status" aria-label="loading" />
      </div>
    );
  }
  if (!loading && dataLength === 0) {
    return <div className={Styles.noDataContainer}>No records found</div>;
  }
  return null;
};

const SummaryHeader = () => (
  <div
    style={{ position: "sticky", top: "0px", zIndex: 99 }}
    className={Styles.accordionSummaryContainer}
  >
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "17%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>Listing Id</th>
          <th className={Styles.summaryHeaderCell}>Product Type</th>
          <th className={Styles.summaryHeaderCell}>Energy Type</th>
          <th className={Styles.summaryHeaderCell}>Delivery Type</th>
          <th className={Styles.summaryHeaderCell}>Listing Exp.</th>
          <th className={Styles.summaryHeaderCell}>Requisitions</th>
        </tr>
      </thead>
    </table>
  </div>
);

const getRateLabel = (conn) => {
  if (!conn) return "";
  if (conn?.energyRateType === "FIXED") return `${conn?.amount}`;
  return `${conn?.energyRateType === "DAM_PLUS" ? "DAM+" : "DAM-"}${
    conn?.amount
  }`;
};

const extractListingId = (name) => {
  if (!name || typeof name !== "string") return null;
  const m = name.match(/^[GC]?(\d+)(?:_|$)/i);
  return m ? m[1] : null;
};

function BilateralConnections({
  matches = [],
  setOpenViewInjectionModal,
  setOpenViewInjectionModalData,
  activeParentTab,
  myListingName,
}) {
  const tabs =
    activeParentTab === "Withdrawn" || activeParentTab === "Expired"
      ? [
          { label: "Placed", key: "Placed" },
          { label: "Received", key: "Received" },
        ]
      : [
          { label: "Completed", key: "Completed" },
          { label: "Placed", key: "Placed" },
          { label: "Received", key: "Received" },
        ];
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const dispatch = useDispatch();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const userDataKey =
    role === "consumer" ? "capacityGenerator" : "capacityConsumer";
  const ledgerBids = useSelector((state) => state?.CapacitySlice?.ledgerBids);

  const completedRows = Array.isArray(matches)
    ? matches.filter((bid) => bid?.status === "SCHEDULED")
    : [];

  const placedRows = Array.isArray(ledgerBids)
    ? ledgerBids.filter((bid) => {
        if (role === bid?.initiatorType) {
          return true;
        } else {
          return false;
        }
      })
    : [];

  const receivedRows = Array.isArray(ledgerBids)
    ? ledgerBids.filter((bid) => {
        if (role !== bid?.initiatorType) {
          return true;
        } else {
          return false;
        }
      })
    : [];

  let rowsToShow = [];
  if (activeTab === "Completed") rowsToShow = completedRows;
  else if (activeTab === "Placed") rowsToShow = placedRows;
  else if (activeTab === "Received") rowsToShow = receivedRows;

  const noRecordText = {
    Completed: "No completed records found.",
    Placed: "No placed records found.",
    Received: "No received records found.",
  };

  function getCounterpartyName(row, role) {
    if (!row) return "NA";
    if (role === "generator") {
      return row?.consumer?.name || "NA";
    } else if (role === "consumer") {
      return row?.generator?.name || "NA";
    }
    return "NA";
  }

  return (
    <div className={Styles.bilateralConnRoot}>
      {/* Sidebar Tabs */}
      <div className={Styles.bilateralConnSidebar}>
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`${Styles.bilateralConnTab} ${
              activeTab === tab.key ? Styles.bilateralConnTabActive : ""
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </div>
        ))}
      </div>
      {/* Table or No Record */}
      <div className={Styles.bilateralConnTableWrap}>
        {rowsToShow && rowsToShow.length > 0 ? (
          <table className={Styles.bilateralConnTable}>
            <thead>
              <tr>
                <th>S.No</th>
                <th style={{ textAlign: "center" }}>Counterparty</th>
                <th style={{ textAlign: "center" }}>Listing Expiry</th>
                {activeParentTab !== "Withdrawn" && (
                  <th style={{ textAlign: "right" }}>
                    {activeTab === "Completed" ? "Contracts" : "Chats"}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {rowsToShow.map((row, idx) => {
                return (
                  <tr key={row.id || idx}>
                    <td>{`${String(idx + 1).padStart(2, "0")}`}</td>

                    {activeTab === "Completed" ? (
                      <td style={{ textAlign: "center" }}>
                        {role === "consumer"
                          ? row.capacityGeneratorName
                          : row.capacityConsumerName}
                        {` - `}{" "}
                        <span style={{ fontWeight: 600, textAlign: "center" }}>
                          {row?.[userDataKey]?.generatorName ||
                            row?.[userDataKey]?.consumerName ||
                            "NA"}
                        </span>
                      </td>
                    ) : (
                      <>
                        <td style={{ textAlign: "center" }}>
                          <span>
                            {row?.[
                              role === "consumer" ? "generator" : "consumer"
                            ]?.name || "NA"}
                          </span>
                        </td>
                      </>
                    )}

                    {activeTab === "Completed" ? (
                      <td style={{ textAlign: "center" }}>
                        {row.listingExpiry ||
                          `${formatDate(row[userDataKey]?.listingExpDate)} - ${row[userDataKey]?.listingExpTime}`}
                      </td>
                    ) : (
                      <td style={{ textAlign: "center" }}>
                        {row?.[role === "consumer" ? "generator" : "consumer"]
                          ?.listingExpiry ||
                          `${formatDate(row[role === "consumer" ? "generator" : "consumer"]?.listingExpDate)} - ${row[role === "consumer" ? "generator" : "consumer"]?.listingExpTime}`}
                      </td>
                    )}

                    {activeParentTab !== "Withdrawn" && (
                      <td
                        style={{
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          paddingRight:
                            activeTab === "Completed" ? "40px" : "8px",
                        }}
                      >
                        {activeTab === "Completed" ? (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenViewInjectionModalData(row);
                              setOpenViewInjectionModal(true);
                            }}
                            className={Styles.bilateralConnEyeBtn}
                          >
                            <EyeIcon style={{ width: 18, height: 18 }} />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className={Styles.chatButton}
                            onClick={() => {
                              let chatId;
                              const counterpartyName = getCounterpartyName(
                                row,
                                role,
                              );
                              if (role === "consumer") {
                                chatId = `${myListingName?.split("_")?.[0]}_${counterpartyName.split("_")?.[0]}`;
                              } else {
                                chatId = `${counterpartyName?.split("_")?.[0]}_${myListingName?.split("_")?.[0]}`;
                              }


                              openBilateralChat(dispatch, {
                                header: counterpartyName,
                                fromUser: myListingName,
                                toUser: counterpartyName,
                                chatId: chatId,
                                type: "BILATERAL",
                                hidechat: false,
                              });
                            }}
                          >
                            View Chat
                          </button>
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div style={{ padding: "40px 0", textAlign: "center" }}>
            {noRecordText[activeTab]}
          </div>
        )}
      </div>
    </div>
  );
}

const SummaryRow = ({
  ele,
  index,
  expanded,
  onToggle,
  userDataKey,
  role,
  openRequisitionModal,
  setOpenRequisitionModal,
  openRequisitionModalData,
  setOpenViewInjectionModalData,
  setOpenRequisitionModalData,
  setOpenViewInjectionModal,
  openViewInjectionModal,
  activeTab,
}) => {
  const [openConnectionHistory, setOpenConnectionHistory] = useState(false);
  const dispatch = useDispatch();
  const mainScreenActiveConnectionLoading = useSelector(
    (state) => state?.CapacitySlice?.fetchMainScreenActiveConnectionLoading,
  );
  const fetchLedgerBidsLoading = useSelector(
    (state) => state?.CapacitySlice?.fetchLedgerBidsLoading,
  );

  const mainScreenActiveConnectionData = useSelector(
    (state) => state?.CapacitySlice?.mainScreenActiveConnection,
  );
  const ledgerBids = useSelector((state) => state?.CapacitySlice?.ledgerBids);

  const matchData =
    activeTab === "Withdrawn" || activeTab === "Expired"
      ? ledgerBids
      : mainScreenActiveConnectionData;

  const showLoader =
    mainScreenActiveConnectionLoading || fetchLedgerBidsLoading;

  if (!ele) return null;
  return (
    <>
      <ConnectionModal
        open={openConnectionHistory}
        onClose={() => setOpenConnectionHistory(false)}
        connectionId={ele?.id}
      />{" "}
      <div
        className={expanded === index ? "" : Styles.detailsMainDrop_inactive}
      >
        <Accordion
          style={{
            backgroundColor: "#f3f5f8",
            marginTop: index === 0 ? "0px" : "3px",
            border:
              expanded === index
                ? "1px solid var(--primary-color-text)"
                : "none",
            borderRadius: "10px",
          }}
          expanded={expanded === index}
          onChange={() => onToggle(index)}
        >
          <AccordionSummary
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              borderBottom: expanded === index ? "1px solid #DFEAF2" : "none",
              borderBottomLeftRadius: expanded === index ? "0px" : "8px",
              borderBottomRightRadius: expanded === index ? "0px" : "8px",
            }}
          >
            <div className={Styles.accordionSummaryContainer}>
              <table
                className={Styles.summaryTable}
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "17%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "12%" }} />
                </colgroup>
                <tbody>
                  <tr style={{ fontWeight: "500" }}>
                    <td className={Styles.summaryCell}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                        }}
                      >
                        <ExpandMoreIcon
                          style={{ fontSize: "18px" }}
                          className={`${Styles.expandIconLeft} ${
                            expanded === index ? Styles.rotateIcon : ""
                          }`}
                        />
                        {index + 1}
                      </div>
                    </td>
                    <td title={ele?.name} className={Styles.summaryCell}>
                      {ele?.name}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele.listingType === "INTRA_DAY"
                        ? "Intraday"
                        : ele.listingType === "NEXT_DAY"
                          ? "Next Day"
                          : ele.listingType === "UPTO_SEVEN_DAYS"
                            ? "Next 7 Days"
                            : ele.listingType === "GREATER_THAN_SEVEN_DAYS"
                              ? "Custom"
                              : // ? "Greater than 7 Days"
                                "-"}{" "}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele?.energyFuelType}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele?.isInterstate ? "Interstate" : "Intra-state"}
                    </td>
                    <td className={Styles.summaryCell}>
                      {formatDate(ele?.listingExpDate) +
                        " - " +
                        formatSlotTime(ele?.listingExpTime)}
                    </td>
                    <td className={Styles.summaryCell}>
                      <button
                        className={Styles.viewAllButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenRequisitionModalData(ele);
                          setOpenRequisitionModal(true);
                        }}
                      >
                        View All
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </AccordionSummary>

          <AccordionDetails
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            {/* details wrapper: show loader inside this container */}
            <div
              style={{
                padding: "10px",
                border: "none",
              }}
              className={Styles.accordionDetailsContainerUploadDocs}
            >
              {showLoader && (
                <div className={Styles.loaderContainer}>
                  <div
                    className={Styles.loader}
                    role="status"
                    aria-label="loading connection"
                  />
                </div>
              )}

              {!showLoader &&
                (Array.isArray(matchData) && matchData.length ? (
                  <>
                    <BilateralConnections
                      myListingName={ele?.name}
                      activeParentTab={activeTab}
                      matches={matchData}
                      userDataKey={userDataKey}
                      parentName={ele?.name}
                      dispatch={dispatch}
                      openViewInjectionModal={openViewInjectionModal}
                      setOpenViewInjectionModal={setOpenViewInjectionModal}
                      setOpenViewInjectionModalData={
                        setOpenViewInjectionModalData
                      }
                      showHeader={mainScreenActiveConnectionData.length > 0}
                    />
                  </>
                ) : (
                  <div className={Styles.noDataContainer}>
                    No matching records
                  </div>
                ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

function ViewRequisitionModal({ data, open, handleClose }) {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const userDataKey =
    role === "consumer" ? "capacityGenerator" : "capacityConsumer";
  const parentDataKey =
    role === "generator" ? "capacityGenerator" : "capacityConsumer";
  const parentName = data?.[parentDataKey]?.name || "";
  const dispatch = useDispatch();
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div style={{ fontSize: "14px" }} className="headingText">
              {role === "consumer"
                ? data.capacityGeneratorName
                : data.capacityConsumerName}
            </div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>

          {
            <div
              style={{
                margin: "7px",
                border: "var(--border-level2)",
                borderRadius: "10px",
              }}
            >
              <table
                className={Styles.accHeaderTable_name}
                style={{
                  width: "100%",
                  tableLayout: "fixed",
                  borderRadius: "10px 10px 0px 0px",
                }}
              >
                <colgroup>
                  <col style={{ width: "18%" }} />
                  <col style={{ width: "18%" }} />
                  <col style={{ width: "18%" }} />
                  <col style={{ width: "18%" }} />
                </colgroup>
                <thead
                  style={{
                    backgroundColor: "#F7FAFF",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                >
                  <tr>
                    <th
                      className={Styles.nameCompanyDetails}
                      style={{ textAlign: "left", paddingLeft: "30px" }}
                    >
                      <div style={{ marginBottom: "5px" }}>
                        {data?.[userDataKey]?.consumerName ||
                          data?.[userDataKey]?.generatorName}
                      </div>
                      <div>{data?.[userDataKey]?.name}</div>
                    </th>
                    <th
                      style={{
                        color: "#617499",
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      Quantity
                    </th>
                    <th
                      style={{
                        color: "#617499",
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      Energy Rate
                    </th>
                    <th
                      style={{
                        color: "#617499",
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      Date Range
                    </th>
                  </tr>
                </thead>
              </table>

              {Array.isArray(data?.bilateralConnections) &&
                data.bilateralConnections
                  .filter((conn) => conn.status !== "REJECTED")
                  .map((conn, i) => (
                    <table
                      className={Styles.ledgerTableHeading}
                      key={conn?.id ?? i}
                      style={{
                        width: "100%",
                        tableLayout: "fixed",
                        color: "var(--fourth-color-text)",
                        fontSize: "12px",
                        backgroundColor: "white",
                      }}
                    >
                      <colgroup>
                        <col style={{ width: "18%" }} />
                        <col style={{ width: "18%" }} />
                        <col style={{ width: "18%" }} />
                        <col style={{ width: "18%" }} />
                      </colgroup>
                      <tbody
                        style={{
                          textAlign: "center",
                          textWrap: "nowrap",
                        }}
                      >
                        <tr style={{ height: "40px" }}>
                          <td
                            style={{
                              textAlign: "left",
                              paddingLeft: "30px",
                              color: "#8C8A96",
                            }}
                          >
                            Connection {i + 1}
                          </td>
                          <td>{conn?.quantity} (MW)</td>
                          <td>{getRateLabel(conn)} (₹/kWh)</td>
                          <td>
                            {formatDate(conn?.dateStartAt)} -{" "}
                            {formatDate(conn?.dateEndAt)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ))}

              <div
                style={{
                  paddingRight: "calc(100vw - 97vw)",
                  backgroundColor: "white",
                  borderRadius: "0px 0px 10px 10px",
                }}
                className={Styles.statusBtnContainer}
              >
                <LeftSideBtns showEditDocs={false} clickedIndex={0} />

                <button
                  type="button"
                  className={Styles.chatButton}
                  onClick={() => {
                    let chatId;

                    if (role === "consumer") {
                      chatId = `${parentName?.split("_")?.[0]}_${data?.[userDataKey]?.name?.split("_")?.[0]}`;
                    } else {
                      chatId = `${data?.[userDataKey]?.name?.split("_")?.[0]}_${parentName?.split("_")?.[0]}`;
                    }

                    openBilateralChat(dispatch, {
                      header: data?.[userDataKey]?.name,
                      fromUser: parentName,
                      toUser: data?.[userDataKey]?.name,
                      chatId: chatId,
                      type: "BILATERAL",
                      hidechat: false,
                    });
                  }}
                >
                  View Chat
                </button>
              </div>
            </div>
          }
        </div>
      </Modal>
    </>
  );
}

const BuySellArchive = ({ type, status }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const userDataKey =
    role === "consumer" ? "capacityGenerator" : "capacityConsumer";
  const [expanded, setExpanded] = useState(0);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const statusFromQuery = searchParams.get("status");
  const [openRequisitionModal, setOpenRequisitionModal] = useState(false);
  const [openRequisitionModalData, setOpenRequisitionModalData] =
    useState(null);
  const [openViewInjectionModal, setOpenViewInjectionModal] = useState(false);
  const [openViewInjectionModalData, setOpenViewInjectionModalData] =
    useState(null);

  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    setExpanded(0);
  }, [type, status]);

  const handleAccordionChange = useCallback(
    (val) => {
      setExpanded((prev) => (prev === val ? -1 : Number(val)));
    },
    [setExpanded],
  );

  const handleLoadMore = () => setPage((prev) => prev + 1);

  useEffect(() => {
    setExpanded(0);
    setPage(0); // Reset page when filters change
    setData([]); // Clear data when filters change
  }, [type, status]);

  useEffect(() => {
    let mounted = true;
    async function fetchData() {
      try {
        setLoading(true);
        const res = await getArchive({ role, status, page: page, size: 10 });
        if (!mounted) return;
        if (res?.data?.code === 200) {
          const newData = res.data.data.page || [];
          setData((prevData) =>
            page === 0 ? newData : [...prevData, ...newData],
          );
          const { totalPages, currentPage } = res.data.data;
          setHasMore(currentPage < totalPages - 1);
        } else {
          setData([]);
          setHasMore(false);
        }
      } catch (error) {
        if (mounted) console.error("Error fetching archive data:", error);
        if (mounted) {
          setData([]);
          setHasMore(false);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchData();
    return () => {
      mounted = false;
    };
  }, [type, status, role, page]);

  useEffect(() => {
    if (!Array.isArray(data) || expanded === -1) return;
    const item = data[expanded];
    const capId = extractListingId(item?.name);
    if (!capId) return;

    dispatch(fetchMainScreenActiveConnection({ capId }));
    dispatch(fetchLedgerBids(capId));
  }, [data, dispatch, expanded]);

  return (
    <>
      <div
        style={{
          height: "calc(100vh - 180px)",
          overflowY: "auto",
          overflowX: "hidden",
          paddingRight: "5px",
        }}
      >
        {openViewInjectionModalData && (
          <ViewRequisitionModal
            open={openViewInjectionModal}
            handleClose={() => {
              setOpenViewInjectionModal(false);
              setOpenViewInjectionModalData(null);
            }}
            data={openViewInjectionModalData}
          />
        )}
        {openRequisitionModal && (
          <ViewInjectionModal
            open={openRequisitionModal}
            handleClose={() => {
              setOpenRequisitionModal(false);
              setOpenRequisitionModalData(null);
            }}
            data={openRequisitionModalData}
          />
        )}
        <LoaderNoData loading={loading} dataLength={data?.length ?? 0} />

        {statusFromQuery === "Closed" ? (
          <>
            {data?.length > 0 && <SummaryHeader />}
            {
              <LoadMorePagination
                hasMore={hasMore}
                onLoadMore={handleLoadMore}
                loading={loading}
              >
                {data?.map((ele, index) => (
                  <SummaryRow
                    setOpenRequisitionModal={setOpenRequisitionModal}
                    setOpenRequisitionModalData={setOpenRequisitionModalData}
                    openRequisitionModal={openRequisitionModal}
                    openRequisitionModalData={openRequisitionModalData}
                    openViewInjectionModal={openViewInjectionModal}
                    setOpenViewInjectionModal={setOpenViewInjectionModal}
                    setOpenViewInjectionModalData={
                      setOpenViewInjectionModalData
                    }
                    key={ele?.id ?? ele?.name ?? index}
                    ele={ele}
                    index={index}
                    expanded={expanded}
                    onToggle={handleAccordionChange}
                    userDataKey={userDataKey}
                    role={role}
                  />
                ))}
              </LoadMorePagination>
            }
          </>
        ) : statusFromQuery === "Withdrawn" ? (
          <>
            {data?.length > 0 && (
              <SummaryHeader statusFromQuery={statusFromQuery} />
            )}

            <LoadMorePagination
              hasMore={hasMore}
              onLoadMore={handleLoadMore}
              loading={loading}
            >
              {data?.map((ele, index) => (
                <SummaryRow
                  activeTab="Withdrawn"
                  setOpenRequisitionModal={setOpenRequisitionModal}
                  setOpenRequisitionModalData={setOpenRequisitionModalData}
                  openRequisitionModal={openRequisitionModal}
                  openRequisitionModalData={openRequisitionModalData}
                  openViewInjectionModal={openViewInjectionModal}
                  setOpenViewInjectionModal={setOpenViewInjectionModal}
                  setOpenViewInjectionModalData={setOpenViewInjectionModalData}
                  key={ele?.id ?? ele?.name ?? index}
                  ele={ele}
                  index={index}
                  expanded={expanded}
                  onToggle={handleAccordionChange}
                  userDataKey={userDataKey}
                  role={role}
                />
              ))}
            </LoadMorePagination>
          </>
        ) : statusFromQuery === "Expired" ? (
          <>
            {data?.length > 0 && (
              <SummaryHeader statusFromQuery={statusFromQuery} />
            )}

            <LoadMorePagination
              hasMore={hasMore}
              onLoadMore={handleLoadMore}
              loading={loading}
            >
              {" "}
              {data?.map((ele, index) => (
                <SummaryRow
                  activeTab="Expired"
                  setOpenRequisitionModal={setOpenRequisitionModal}
                  setOpenRequisitionModalData={setOpenRequisitionModalData}
                  openRequisitionModal={openRequisitionModal}
                  openRequisitionModalData={openRequisitionModalData}
                  openViewInjectionModal={openViewInjectionModal}
                  setOpenViewInjectionModal={setOpenViewInjectionModal}
                  setOpenViewInjectionModalData={setOpenViewInjectionModalData}
                  key={ele?.id ?? ele?.name ?? index}
                  ele={ele}
                  index={index}
                  expanded={expanded}
                  onToggle={handleAccordionChange}
                  userDataKey={userDataKey}
                  role={role}
                />
              ))}
            </LoadMorePagination>
          </>
        ) : null}
      </div>
    </>
  );
};

export default BuySellArchive;
